module.exports = __webpack_public_path__ + "static/media/oops_icon.aed5dc01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/via/images/oops_icon.svg
// module id = 475
// module chunks = 0